export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13958.b07c8f15.jpg";